import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../../../hooks/useAuth";
import AlertMessageComponent from "../../../components/AlertMessageComponent";
import AddApiKeys from "./AddApiKeys";
import ListApiKeys from "./ListApiKeys";
import SuccessMessageComponent from "../../../components/SuccessMessageComponent";

export default function ManageApiKeys() {
    const state = useSelector(state => state.userManagementSlice);
    const [errorResponse, setErrorResponse] = useState("");
    const { user } = useAuth();
    const [searchParams, setSearchParams] = React.useState({
        uniqueId: "",
        name: "",
        status: "",
        userRole: "",
    });
    const [operationStatus, setOperationStatus] = useState({
        success: false,
        failed: false,
        message: "",
    });

    const handleCloseSuccessMessage = () => {
        setOperationStatus({ success: false, failed: false, message: "" });
    };

    if (!user?.roleName) return <></>;

    return (
        <div>
            {state.controls.showAddApiKeysForm ? (
                <AddApiKeys setOperationStatus={setOperationStatus} />
            ) : (
                <ListApiKeys searchParams={searchParams} setSearchParams={setSearchParams} setOperationStatus={setOperationStatus} />
            )}

            <AlertMessageComponent
                message={errorResponse}
                fieldName={"errorResponse"}
                handleClose={() => setErrorResponse("")}
                show={Boolean(errorResponse)}
            />
            {operationStatus.success && (
                <SuccessMessageComponent message={operationStatus.message} handleClose={handleCloseSuccessMessage} show={operationStatus.success} />
            )}
        </div>
    );
}
